module.exports = __webpack_public_path__ + "static/media/stress_issues.c7f0e8f4.jpg";